import { IconBrandReason, IconCalendar, IconChecks, IconClick, IconComet, IconCopy, IconDownload, IconEscalator, IconEye, IconHandClick, IconLink, IconPresentationAnalytics, IconTrash } from '@tabler/icons-react';
import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { toast } from 'sonner';
import { getApi } from '../../../api/call.api';
import { urlApi } from '../../../api/url.api';
import ConfirmationModal from '../../../components/ConfirmationModal/ConfirmationModal';
import { loadingHide, loadingShow } from '../../../loadingUi/loading.controller';
import { accessKeys } from '../../../statics/accessKeys';
import { accessCheck } from '../../../utils/accessCheck';
import { dateTimeConverter } from '../../../utils/dateTimeConverter';
import UpdatePromotionDataModal from './UpdatePromotionDataModal';

const PromotionLinkCard = ({ cardData, resetFunction, isMain = false }) => {

    const navigate = useNavigate();

    function onCopy(copyText) {
        navigator.clipboard
            .writeText(copyText)
            .then(() => {
                toast.success("Link copied");
            })
            .catch(() => {
                toast.error("something went wrong");
            });
    }
    async function deleteLink(linkId) {
        loadingShow();
        let resp = await getApi(urlApi.deletePromotion + linkId);
        loadingHide();
        if (resp.responseCode === 200) {
            toast.success(resp.message);
            resetFunction?.();
        } else {
            toast.error(resp.message);
        }
    }

    return (
        <div className="border-1 border-[var(--primary)] !mb-3 !p-3 rounded-2xl">
            <div className="flex justify-center md:justify-between flex-wrap !mb-4 md:!mb-1 items-center gap-3">
                <div className='flex gap-2 items-center'>
                    <div className="bg-[var(--primary-30)] p-1.5 aspect-square rounded-full">
                        <img src={cardData?.favicon} alt="" className='h-6 aspect-square object-cover' />
                    </div>
                    <p className='text-sm font-medium text-primary'>{cardData?.promoTitle || "PROMOTION"}</p>
                </div>
                <div className="flex items-center gap-2">
                    <button className='flex gap-2 text-sm items-center px-2 py-1 rounded-full bg-[#7A829C20] text-[#7A829C]' onClick={() => onCopy(cardData?.promoLink)}><IconCopy size={18} /> Copy</button>
                    {/* <button className='flex gap-2 text-sm items-center px-2 py-1 rounded-full  bg-[#0075FF20] text-[#0075FF]'><IconShare size={18} /> Share</button> */}
                    {isMain && <UpdatePromotionDataModal baseData={cardData} callback={() => resetFunction()} />}
                    {(isMain && accessCheck(accessKeys.viewPromotionDetails)) && <button onClick={() => navigate("/promotion-details", { state: cardData })} className='flex gap-2 text-sm items-center px-2 py-1 rounded-full  bg-[#15BC0020] text-[#15BC00]'><IconEye size={18} /> Details</button>}
                    {(isMain && accessCheck(accessKeys.deletePromotionLink)) && <ConfirmationModal buttonComponent={<button className='flex gap-2 text-sm items-center px-2 py-1 rounded-full  bg-[#ff004c20] text-[#ff0022]'><IconTrash size={18} /> Delete</button>} confirmationText={"Are You Sure Want To Delete This Promotion?"} onConfirm={() => deleteLink(cardData?._id)} />}
                </div>
            </div>
            <div className='!px-2'>
                <div>
                    <p className='text-sm flex items-center gap-2 mb-[6px]'> <IconClick size={20} /> Promo Link: <Link className='underline text-xs' to={cardData?.promoLink} target='_blank'>{cardData?.promoLink}</Link>  </p>
                    <p className='text-sm flex items-center gap-2 mb-[6px]'> <IconLink size={20} /> Destination Link: <Link className='underline text-xs' to={cardData?.destinationLink} target='_blank'>{cardData?.destinationLink}</Link>  </p>
                    <p className='text-sm flex items-center gap-2 mb-[6px]'> <IconCalendar size={20} /> Created: <span className='text-xs'>{dateTimeConverter(cardData?.createdAt)}</span>  </p>
                    <div className="flex items-center gap-3">
                        {cardData?.adMedium && <div className="flex items-center !gap-2">
                            <IconEscalator size={18} />
                            <p className="text-xs">{cardData?.adMedium}</p>
                        </div>}
                        {cardData?.creativeType && <div className="flex items-center !gap-2">
                            <IconComet size={18} />
                            <p className="text-xs">{cardData?.creativeType}</p>
                        </div>}
                    </div>
                </div>
                <div className="both-side-faded-line" />
                <div className="grid grid-cols-2 md:grid-cols-6 !mb-3 gap-3">
                    <StatsSection icon={<IconClick />} title={"Link Clicks"} value={cardData?.linkClicks || 0} />
                    <StatsSection icon={<IconHandClick />} title={"Unique Clicks"} value={cardData?.uniqueLinkClicks || 0} />
                    <StatsSection icon={<IconChecks />} title={"Installation"} value={cardData?.installs || 0} />
                    <StatsSection icon={<IconBrandReason />} title={"Re-Installation"} value={cardData?.reInstalls || 0} />
                    <StatsSection icon={<IconDownload />} title={"Download Click"} value={cardData?.downLoadClicks || 0} />
                    <StatsSection icon={<IconPresentationAnalytics />} title={"Re-engage"} value={cardData?.reEngage || 0} />
                </div>
                <p className='mb-0 text-sm'>
                    <span className='font-medium'>Note:</span> <span className='text-[var(--secondary-text)]'>{cardData?.description || "--"}</span>
                </p>
            </div>
        </div>
    )
}

export default PromotionLinkCard;

const StatsSection = ({ icon, title, value }) => {
    return (
        <div className="flex col-span-1 w-full items-center gap-2 justify-center">
            {icon}
            <div>
                <p className="mb-0 text-sm text-[var(--secondary-text)]">{title}</p>
                <p className="mb-0 font-medium text-center">{value}</p>
            </div>
        </div>
    )
}